// removed by extract-text-webpack-plugin
module.exports = {"root":"Sk35y5V","form":"_3aYACmj","inputField":"EHatgfs","email":"hm_8elc","button":"_1xL2mZf","savePrompt":"_2mF9ZOR","icon":"ko37ZqM","privacy":"_1Z6d86Y","message":"_2YuQJ0I","thankYou":"_7aIzEsK","createdMessage":"_1PlxTSo"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanelTiny/components/JobMailTinyForm/JobMailTinyForm.less
 ** module id = 893
 ** module chunks = 0
 **/